import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { CheckRound, CircleTimes, IsOpen } from '../../../components/Icon';

import { selectWorks, selectPermissions, selectWork } from '../../Api/selectors';

import {
  ASSIGN_WORKFLOW_TO_VEHICLE,
  REQUEST_VEHICLE_PROPERTIES,
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  REQUEST_VEHICLE_WORKFLOW_TASKS,
} from '../constants';

import ButtonComponent from '../../../containers/App/Components/Button/Button';
import LoadingDetailsPageCard from '../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import { WithWorkflow } from '../../Workflows/components/WithWorkflow';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import { getCompanyWorkflows } from '../../Companies/actions';
import { assignWorkflowToVehicle, getVehicleWorkflowTasks } from '../actions';
import { selectWorkflows } from '../../Workflows/selectors';

import { selectCompanyWorkflows } from '../../Companies/selectors';
import { REQUEST_WORKFLOWS } from '../../Workflows/constants';
import { REQUEST_COMPANY_WORKFLOWS } from '../../Companies/constants';
import cn from 'classnames';
import styles from './CardWorkflowManagement.module.css';
import LoadingField from '../../../containers/App/Components/LoadingField/LoadingField';

const TASK_ACTIONS = ['do_nothing', 'cancel'];

const STATE = {
  isOpen: false,
  showEditWorkflowModal: false,
  tasks: [],
  newWorkflow: null,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleWorkflowManagementCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.getCompanyWorkflows(result => {});
  }

  componentDidUpdate(prevProps, prevState) {}

  get vehicle() {
    return this.props.vehicle;
  }

  get options() {
    return this.props.attachedWorkflows?.map(w => ({ label: w.name, value: w.id }));
  }

  get dto() {
    const updatedTasks = this.state.tasks.map(task => {
      if (task.status === 'in_progress') {
        return {
          ...task,
          action: 'cancel',
        };
      }
      return task;
    });

    return {
      vehicleId: this.vehicle.id,
      workflowId: this.state.newWorkflow?.value,
      actions: {
        tasks: updatedTasks,
      },
    };
  }

  iconStatus(task) {
    if (task?.done) {
      return '2';
    }

    return '1';
  }

  selectAction = (selectedTask, action) => {
    this.setState(prevState => ({
      tasks: prevState.tasks.map(task => {
        if (task === selectedTask) {
          return { ...task, action };
        }
        return task;
      }),
    }));
  };

  selectWorkflow(workflow) {
    this.setState({ newWorkflow: workflow });
  }

  edit() {
    this.props.assignWorkflow(this.dto, () => {});
    return this.reset();
  }

  handleOpenModal() {
    this.props.getVehicleWorkflowTasks(result => {
      this.setState({ tasks: result?.tasks ?? [], showEditWorkflowModal: true });
    });
  }

  renderTasksSection() {
    return this.state.tasks
      ?.filter(t => t?.status === 'complete')
      .map(task => {
        return (
          <HBox key={task?.name} className={styles.tasksGrid}>
            <HBox left>
              <div style={{ color: '#0BCF97' }}>
                <CheckRound />
              </div>
              {this.lbl(`vehicle.property.${task?.name}`)}
            </HBox>
            <HBox right gap={'4px'}>
              {TASK_ACTIONS.map(action => {
                return (
                  <ButtonComponent
                    key={action}
                    style={task?.action === action ? 'ButtonSoftPrimary' : 'ButtonSoftLight'}
                    onClick={() => this.selectAction(task, action)}
                  >
                    {this.lbl(`workflows.tasks.action.${action}`)}
                  </ButtonComponent>
                );
              })}
            </HBox>
          </HBox>
        );
      });
  }

  renderEditModal() {
    if (this.props.workTasks)
      return (
        <ModalComponent>
          <VBox>
            <LoadingField></LoadingField>
            <LoadingField></LoadingField>
            <LoadingField></LoadingField>
          </VBox>
        </ModalComponent>
      );
    const filteredTasks = this.state.tasks.filter(t => t?.status === 'complete');
    const allActionsSelected = filteredTasks.every(task => task.action);
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('vehicle.info.workflow_management')}>
        <div className="mb-2">{this.renderTasksSection()}</div>
        <SearchSelect options={this.options} value={this.state.newWorkflow} onChange={this.selectWorkflow.bind(this)} />
        <div className="d-flex gap-2 mt-2 justify-content-center">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            disabled={this.props.work || !allActionsSelected}
            onClick={this.edit.bind(this)}
          >
            {this.lbl('confirm')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (this.props.work) return <LoadingDetailsPageCard />;
    if (this.props.fromKanban) {
      return (
        <>
                {this.state.showEditWorkflowModal && this.renderEditModal()}

<div className={styles.containerLabel}>
              <div className={styles.formField}>
                <div className={styles.textContainer}>
                  {this.vehicle?.workflow_id && (
                    <WithWorkflow label workflow_id={this.vehicle?.workflow_id} propertyName={'name'} />
                  )}
                </div>

                <div className={styles.labelTable}>
                  <ButtonComponent style={'ButtonSoftEdit'} onClick={() => this.handleOpenModal()}>
                    {this.lbl('edit')}
                  </ButtonComponent>
                </div>
              </div>
            </div>        </>
      );
    }
    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        {this.state.showEditWorkflowModal && this.renderEditModal()}
        <HBox left className={styles.header}>
          <h2 className="card-title mb-0 text-muted" style={{ whiteSpace: 'nowrap' }}>
            {this.lbl('vehicle.info.workflow_management')}
          </h2>
          <div style={{ marginLeft: 'auto' }} onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
            <IsOpen />
          </div>
        </HBox>

        {this.state.isOpen && (
          <>
            <div className={styles.containerLabel}>
              <div className={styles.formField}>
                <div className={styles.textContainer}>
                  {this.vehicle?.workflow_id && (
                    <WithWorkflow label workflow_id={this.vehicle?.workflow_id} propertyName={'name'} />
                  )}
                </div>

                <div className={styles.labelTable}>
                  <ButtonComponent style={'ButtonSoftEdit'} onClick={() => this.handleOpenModal()}>
                    {this.lbl('edit')}
                  </ButtonComponent>
                </div>
              </div>
            </div>
          </>
        )}
      </Card>
    );
  }
}

VehicleWorkflowManagementCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      `${REQUEST_VEHICLE_PROPERTIES}-${ownProps.vehicle?.id}`,
      REQUEST_WORKFLOWS,
      REQUEST_COMPANY_WORKFLOWS,

      ASSIGN_WORKFLOW_TO_VEHICLE,
    ]),
    workTasks: selectWork(REQUEST_VEHICLE_WORKFLOW_TASKS),
    availableWorkflows: selectWorkflows(),

    attachedWorkflows: selectCompanyWorkflows(),

    permissions: selectPermissions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getCompanyWorkflows(callback) {
      const creditorCompanyId = ownProps.vehicle.creditor_company;
      if (creditorCompanyId) dispatch(getCompanyWorkflows(creditorCompanyId, callback));
    },
    getVehicleWorkflowTasks(callback) {
      dispatch(getVehicleWorkflowTasks(ownProps.vehicle?.id, callback));
    },
    assignWorkflow(dto, callback) {
      dispatch(assignWorkflowToVehicle(dto, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleWorkflowManagementCard = compose(withConnect, withRouter)(VehicleWorkflowManagementCardComp);
